import React from 'react';
import { createPortal } from 'react-dom';
import { Image } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

const FacetModal = (props) => {
  const { img } = props; // props.title exists
  // TODO: fix Header bar is to big
  return createPortal(
    <Modal
      {...props}
      size='sm' // TODO: maybe change size depending on image
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      {/* <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>
          {title}
        </Modal.Title>
      </Modal.Header> */}
      <Modal.Body>
        <Image src={img} fluid className='mx-auto my-2' style={{ display: 'block' }} />
      </Modal.Body>
    </Modal>,
    document.querySelector('#modal')
  );
};

export default FacetModal;
